import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';
import {SearchHeader, SearchPageData, SearchResults, useRouterFns, useSearchItems} from 'epic-ue-search';
import parse from 'url-parse';
import root from 'window-or-global';
import {useNavigate} from 'react-router-dom';
import Helmet from 'react-helmet';
import {useLoading, useNotFound} from '../../utils/loadingUtils';
import Error404 from '../error/Error404';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import {PageData} from '@epic-mw/types';

const SearchWrap = styled.div`
    min-height: 60vh;
    .load-screen {
        padding-bottom: 32px;
    }
`;

interface Props {
    pageData?: SearchPageData;
}

const SearchContainer = ({pageData}: Props) => {
    const navigate = useNavigate();
    const {routeNavigate} = useRouterFns(navigate);
    const locale = getLocale();

    const {pages, total, isLoading: searchLoading} = useSearchItems(locale);

    const isLoading = useLoading(pageData as PageData);
    const notFound = useNotFound(pageData as PageData);

    if (isLoading) {
        return <LoadIndicator fill />;
    }

    if (notFound) {
        return <Error404 />;
    }

    const parsedUrl = parse(root.location.href, true);
    const queryKeyword = String(parsedUrl.query.keyword || '');
    const filter = String(parsedUrl.query.filter || '');

    const epicSearchFilter = pageData?.epicSearchFilter;

    return (
        <SearchWrap>
            {getHelmetForMetaTags(pageData)}

            <Helmet meta={[{name: 'robots', content: 'noindex,nofollow'}]} />

            <SearchHeader
                isLoading={searchLoading}
                routeNavigate={routeNavigate}
                enableCustomFilter={epicSearchFilter?.enableCustomFilter}
                queryUrl={parsedUrl.query}
                searchFilters={epicSearchFilter?.searchFilters}
                total={total}
                pageTitle={pageData?.pageTitle}
                description={pageData?.description}
                noResultsBlock={pageData?.noResultsBlock}
                resultsLabel={pageData?.resultsLabel}
                searchPlaceholder={pageData?.searchPlaceholder}
            />

            <SearchResults accentColor={'sky'} isLoading={searchLoading} loadingIcon={<LoadIndicator />} pages={pages} total={total} searchKeyword={queryKeyword} filter={filter} />
        </SearchWrap>
    );
};

export default SearchContainer;
